import { GROUPS, PREFIX_PROXY } from '@/service/apiConf';
import { get } from '@/service/request';
import { assign } from 'lodash';

export const sort_metric_options = [
  'node_cpu_utilisation',
  'node_load1',
  'gpu_node_resource_used_utilisation_all',
  'node_memory_utilisation',
  'node_disk_size_utilisation',
  'node_disk_inode_utilisation',
  'node_pod_utilisation',
];

const metrics_filter = [
  'gpu_node_resource_used_utilisation_all',

  'node_cpu_utilisation',
  'node_cpu_usage',
  'node_cpu_total',

  'node_memory_utilisation',
  'node_memory_usage_wo_cache',
  'node_memory_total',

  'node_disk_size_utilisation',
  'node_disk_size_usage',
  'node_disk_size_capacity',

  'node_pod_utilisation',
  'node_pod_running_count',
  'node_pod_quota',

  'node_disk_inode_utilisation',
  'node_disk_inode_total',
  'node_disk_inode_usage',

  'node_load1$',
];

const scheduler_metrics_filter = ['scheduler_schedule_attempts'];

const status = ['apiserver_request_latencies', 'apiserver_request_rate'];

export const UrlMap = () => {
  return {
    fetchData: () => `${PREFIX_PROXY.vapis(GROUPS.clusterinfo)}/clusterinfo`,
    clusterMonitor: () => `${PREFIX_PROXY.vapis(GROUPS.monitoring)}/nodes`,
    K8sStatus: () => `${PREFIX_PROXY.vapis(GROUPS.monitoring)}/components/apiserver`,
    getComponentStatus: () => `${PREFIX_PROXY.vapis(GROUPS.monitoring)}/components`,
    getSchedulerMonitor: () => `${PREFIX_PROXY.vapis(GROUPS.monitoring)}/cluster`,
  };
};

export function getComponentStatus(cluster) {
  return get(`${UrlMap().getComponentStatus()}`);
}

export function fetchData() {
  return get(`${UrlMap().fetchData()}`, {}, { flag: true });
}

export function clusterMonitor(cluster, params?: any) {
  const defaultParams = {
    type: 'rank',
    metrics_filter: metrics_filter.join('|'),
    page: 1,
    limit: 5,
    sort_type: 'desc',
    sort_metric: params.sort_metric || sort_metric_options[0],
  };
  return get(`${UrlMap().clusterMonitor()}`, assign(defaultParams, params));
}

export function gerK8sStatus(cluster: any) {
  const defaultParams = {
    metrics_filter: status.join('|'),
  };
  return get(`${UrlMap().K8sStatus()}`, assign(defaultParams), { flag: true });
}

export function getSchedulerMonitor(cluster, params?: any) {
  const defaultParams = {
    metrics_filter: scheduler_metrics_filter.join('|'),
  };
  return get(`${UrlMap().getSchedulerMonitor()}`, assign(defaultParams, params), {
    flag: true,
  });
}
